var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/AppBar/Application.tsx
import React14 from "react";

// src/AppBarEx.tsx
import { AppBar, Container, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { FlexGrowRow, FlexRow } from "@xylabs/react-flexbox";
import React from "react";
var AppBarExInner = /* @__PURE__ */ __name(({ children, menu, contextToolbar, systemToolbar, responsive, ...props }) => {
  const { breakpoints } = useTheme();
  const belowSm = useMediaQuery(breakpoints.down("sm"));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FlexRow, {
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    ...props
  }, contextToolbar ?? /* @__PURE__ */ React.createElement(Toolbar, null), /* @__PURE__ */ React.createElement(FlexGrowRow, null, belowSm && responsive ? null : children), systemToolbar ?? /* @__PURE__ */ React.createElement(Toolbar, null), menu), belowSm && children && responsive ? /* @__PURE__ */ React.createElement(Toolbar, null, children) : null);
}, "AppBarExInner");
var AppBarEx = /* @__PURE__ */ __name(({ container, children, menu, contextToolbar, systemToolbar, responsive, ...props }) => {
  return /* @__PURE__ */ React.createElement(AppBar, {
    position: "static",
    ...props
  }, container ? /* @__PURE__ */ React.createElement(Container, {
    maxWidth: container
  }, /* @__PURE__ */ React.createElement(AppBarExInner, {
    children,
    contextToolbar,
    menu,
    responsive,
    systemToolbar
  })) : /* @__PURE__ */ React.createElement(AppBarExInner, {
    children,
    contextToolbar,
    menu,
    responsive,
    systemToolbar
  }));
}, "AppBarEx");

// src/Toolbar/Context/ContextToolbar.tsx
import { Toolbar as Toolbar2 } from "@mui/material";
import React4 from "react";

// src/Toolbar/Context/LogoLinkEx.tsx
import { Typography, useTheme as useTheme3 } from "@mui/material";
import { assertEx } from "@xylabs/assert";
import { FlexRow as FlexRow2 } from "@xylabs/react-flexbox";
import { LinkEx } from "@xylabs/react-link";
import React3 from "react";

// src/Toolbar/Context/Logo.tsx
import { LogoDevOutlined, LogoDevRounded } from "@mui/icons-material";
import { useTheme as useTheme2 } from "@mui/material";
import React2 from "react";
var Logo = /* @__PURE__ */ __name((props) => {
  const theme = useTheme2();
  return theme.palette.mode === "dark" ? /* @__PURE__ */ React2.createElement(LogoDevRounded, props) : /* @__PURE__ */ React2.createElement(LogoDevOutlined, props);
}, "Logo");

// src/Toolbar/Context/LogoLinkEx.tsx
var LogoLinkEx = /* @__PURE__ */ __name(({ logo, to = "/", href, version = false, ...props }) => {
  const theme = useTheme3();
  assertEx(href === void 0, () => "href is not supported");
  return /* @__PURE__ */ React3.createElement(LinkEx, {
    to,
    ...props
  }, /* @__PURE__ */ React3.createElement(FlexRow2, {
    paddingX: "4px"
  }, logo ?? /* @__PURE__ */ React3.createElement(Logo, {
    sx: {
      color: theme.palette.primary.contrastText,
      height: "40px",
      width: "40px"
    }
  }), version ? /* @__PURE__ */ React3.createElement(Typography, {
    position: "absolute",
    borderRadius: 1,
    right: 6,
    color: theme.palette.getContrastText(theme.palette.text.primary),
    bottom: 0,
    bgcolor: theme.palette.text.primary,
    paddingX: "2px",
    lineHeight: 1,
    variant: "caption",
    border: `1px ${theme.palette.getContrastText(theme.palette.primary.main)} solid`
  }, typeof version === "string" ? version : "1.0") : null));
}, "LogoLinkEx");

// src/Toolbar/Context/ContextToolbar.tsx
var ContextToolbar = /* @__PURE__ */ __name(({ children, logo, logoTo = "/", version = false, ...props }) => {
  return /* @__PURE__ */ React4.createElement(Toolbar2, props, /* @__PURE__ */ React4.createElement(LogoLinkEx, {
    logo,
    version,
    to: logoTo
  }), children);
}, "ContextToolbar");

// src/Toolbar/System/SystemToolbar.tsx
import { Toolbar as Toolbar3 } from "@mui/material";
import { DarkModeIconButton } from "@xylabs/react-app-settings";
import React13 from "react";

// src/SiteMenu/hooks/useMenuItemsShared.tsx
import { useCollapsible } from "@xylabs/react-shared";
import { useMemo } from "react";
var useMenuItemsShared = /* @__PURE__ */ __name(() => {
  const { collapse, collapseEnd, setCollapse, setCollapseEnd } = useCollapsible();
  const onMenuItemToggle = /* @__PURE__ */ __name((open) => {
    setCollapse?.((previous) => open ? false : previous);
    setCollapseEnd?.((previous) => open ? false : previous);
  }, "onMenuItemToggle");
  const defaultSiteMenuListItemProps = useMemo(() => ({
    collapseEnd,
    dense: true,
    iconOnly: collapse,
    sx: {
      px: "8px"
    }
  }), [
    collapse,
    collapseEnd
  ]);
  return {
    defaultSiteMenuListItemProps,
    onMenuItemToggle
  };
}, "useMenuItemsShared");

// src/SiteMenu/Menu.tsx
import { Menu as MenuIcon2, Settings as SettingsIcon } from "@mui/icons-material";
import { IconButton as IconButton2, List as List2, SwipeableDrawer } from "@mui/material";
import { FlexRow as FlexRow4 } from "@xylabs/react-flexbox";
import React11, { useEffect, useState as useState2 } from "react";

// src/SiteMenu/MenuListItem/MenuListItemContainer.tsx
import { ListItemText, useTheme as useTheme5 } from "@mui/material";
import { FlexRow as FlexRow3 } from "@xylabs/react-flexbox";
import { useCollapsible as useCollapsible2 } from "@xylabs/react-shared";
import React10, { useState } from "react";
import { NavLink } from "react-router-dom";

// src/SiteMenu/MenuListItem/list-item-components/ListItemTooltip.tsx
import { InfoOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { FlexCol } from "@xylabs/react-flexbox";
import React5 from "react";
var ListItemTooltip = /* @__PURE__ */ __name(({ title, ...props }) => {
  return /* @__PURE__ */ React5.createElement(Tooltip, {
    title,
    placement: "right",
    ...props
  }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(FlexCol, {
    justifyContent: "center"
  }, /* @__PURE__ */ React5.createElement(InfoOutlined, {
    sx: {
      color: "grey"
    }
  }))));
}, "ListItemTooltip");

// src/SiteMenu/MenuListItem/list-item-components/MenuIcon.tsx
import { Typography as Typography2 } from "@mui/material";
import React6 from "react";
var MenuIcon = /* @__PURE__ */ __name(({ icon, ...props }) => {
  return /* @__PURE__ */ React6.createElement(Typography2, {
    display: "flex",
    ...props
  }, icon);
}, "MenuIcon");

// src/SiteMenu/MenuListItem/list-item-components/MenuListItem.tsx
import { ListItem } from "@mui/material";
import React7 from "react";
var MenuListItem = /* @__PURE__ */ __name(({ iconOnly, collapseEnd, sx, children, dense, ...props }) => {
  const listItemSx = iconOnly ? {
    borderRadius: "50%",
    display: "inline-flex",
    flexGrow: 0,
    width: "auto"
  } : {
    width: "100%"
  };
  const spacingSx = collapseEnd ? {
    columnGap: 0
  } : {
    columnGap: 1.5
  };
  const paddingSx = dense ? {
    px: "8px"
  } : {
    px: "12px"
  };
  return /* @__PURE__ */ React7.createElement(ListItem, {
    sx: {
      ...listItemSx,
      ...spacingSx,
      ...paddingSx,
      ...sx
    },
    ...props
  }, children);
}, "MenuListItem");

// src/SiteMenu/MenuListItem/sub-nav/SubNavListItemCollapse.tsx
import { Collapse, List } from "@mui/material";
import React8 from "react";
var SubNavListItemsCollapse = /* @__PURE__ */ __name(({ collapse, openSubNav, children, ...props }) => {
  return /* @__PURE__ */ React8.createElement(Collapse, {
    in: collapse == true ? false : openSubNav,
    ...props
  }, /* @__PURE__ */ React8.createElement(List, null, children));
}, "SubNavListItemsCollapse");

// src/SiteMenu/MenuListItem/sub-nav/SubNavToggleIconButton.tsx
import { ExpandMore } from "@mui/icons-material";
import { IconButton, useTheme as useTheme4 } from "@mui/material";
import React9 from "react";
var SubNavToggleIconButton = /* @__PURE__ */ __name(({ setOpenSubNav, openSubNav }) => {
  const theme = useTheme4();
  return /* @__PURE__ */ React9.createElement(IconButton, {
    onClick: /* @__PURE__ */ __name((event) => {
      event.stopPropagation();
      setOpenSubNav?.(!openSubNav);
    }, "onClick"),
    sx: {
      marginRight: theme.spacing(0.5)
    }
  }, /* @__PURE__ */ React9.createElement(ExpandMore, null));
}, "SubNavToggleIconButton");

// src/SiteMenu/MenuListItem/MenuListItemContainer.tsx
var MenuListItemContainer = /* @__PURE__ */ __name(({ style, icon, iconMenuTextSpacing, iconOnly, onButtonClick, primary, subNavListItems, sx, tooltip, to, ...props }) => {
  const { dense } = props;
  const theme = useTheme5();
  const { collapse } = useCollapsible2();
  const [openSubNav, setOpenSubNav] = useState(false);
  const [hovered, setHovered] = useState(false);
  const resolvedIconMenuTextSpacing = iconMenuTextSpacing ?? theme.spacing(1);
  return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(MenuListItem, {
    disableGutters: true,
    iconOnly,
    onClick: onButtonClick,
    dense,
    sx: {
      justifyContent: "space-between",
      ...sx
    },
    style: {
      whiteSpace: "nowrap",
      ...style
    },
    ...props
  }, /* @__PURE__ */ React10.createElement(NavLink, {
    className: "site-menu-nav-link",
    onMouseEnter: /* @__PURE__ */ __name((e) => {
      const el = e.currentTarget;
      el.style.cursor = "pointer";
      el.style.textDecoration = "underline";
      el.style.filter = "brightness(75%)";
      setHovered(true);
    }, "onMouseEnter"),
    onMouseLeave: /* @__PURE__ */ __name((e) => {
      const el = e.currentTarget;
      el.style.cursor = "default";
      el.style.textDecoration = "none";
      el.style.filter = "";
      setHovered(false);
    }, "onMouseLeave"),
    color: "inherit",
    to: to ?? "",
    viewTransition: true,
    style: {
      color: "inherit",
      textDecoration: "none",
      display: "flex",
      alignItems: "center"
    }
  }, /* @__PURE__ */ React10.createElement(MenuIcon, {
    icon,
    paddingRight: resolvedIconMenuTextSpacing,
    color: hovered ? "secondary" : "inherit"
  }), /* @__PURE__ */ React10.createElement(ListItemText, {
    primary
  })), /* @__PURE__ */ React10.createElement(FlexRow3, {
    style: {
      marginLeft: theme.spacing(1)
    }
  }, subNavListItems ? /* @__PURE__ */ React10.createElement(SubNavToggleIconButton, {
    setOpenSubNav,
    openSubNav
  }) : null, tooltip ? /* @__PURE__ */ React10.createElement(ListItemTooltip, {
    title: tooltip
  }) : null)), subNavListItems ? /* @__PURE__ */ React10.createElement(SubNavListItemsCollapse, {
    openSubNav,
    collapse
  }, subNavListItems?.map((item, index) => /* @__PURE__ */ React10.createElement(MenuListItemContainer, {
    dense,
    sx: {
      pl: theme.spacing(1)
    },
    key: index,
    ...item
  }))) : null);
}, "MenuListItemContainer");

// src/SiteMenu/Menu.tsx
var SiteMenu = /* @__PURE__ */ __name(({ children, onMenuToggle, side = "right", ...props }) => {
  const [open, setOpen] = useState2(false);
  useEffect(() => {
    onMenuToggle?.(open);
  }, [
    onMenuToggle,
    open
  ]);
  return /* @__PURE__ */ React11.createElement(FlexRow4, {
    alignItems: "stretch",
    ...props
  }, /* @__PURE__ */ React11.createElement(IconButton2, {
    size: "small",
    color: "inherit",
    onClick: /* @__PURE__ */ __name(() => {
      setOpen(!open);
    }, "onClick")
  }, /* @__PURE__ */ React11.createElement(MenuIcon2, {
    fontSize: "large"
  })), /* @__PURE__ */ React11.createElement(SwipeableDrawer, {
    anchor: side,
    open,
    onClick: /* @__PURE__ */ __name(() => setOpen(false), "onClick"),
    onKeyDown: /* @__PURE__ */ __name(() => setOpen(false), "onKeyDown"),
    onClose: /* @__PURE__ */ __name(() => setOpen(false), "onClose"),
    onOpen: /* @__PURE__ */ __name(() => setOpen(true), "onOpen")
  }, children ?? /* @__PURE__ */ React11.createElement(List2, null, /* @__PURE__ */ React11.createElement(MenuListItemContainer, {
    primary: "Settings",
    icon: /* @__PURE__ */ React11.createElement(SettingsIcon, null),
    to: "/settings"
  }))));
}, "SiteMenu");

// src/SiteMenu/MenuSection.tsx
import { Collapse as Collapse2, ListSubheader } from "@mui/material";
import { FlexCol as FlexCol2 } from "@xylabs/react-flexbox";
import React12 from "react";
var MenuSection = /* @__PURE__ */ __name(({ iconMenuTextSpacing, listItems, showTitle = true, title, ...props }) => {
  return /* @__PURE__ */ React12.createElement(FlexCol2, {
    alignItems: "stretch",
    ...props
  }, /* @__PURE__ */ React12.createElement(Collapse2, {
    in: showTitle,
    timeout: 700
  }, /* @__PURE__ */ React12.createElement(ListSubheader, null, title)), listItems.map((item, index) => /* @__PURE__ */ React12.createElement(MenuListItemContainer, {
    key: index,
    iconMenuTextSpacing,
    ...item
  })));
}, "MenuSection");

// src/Toolbar/System/SystemToolbar.tsx
var SystemToolbar = /* @__PURE__ */ __name(({ children, darkModeButton = false, menuItems, onMenuToggle, precedingChildren, ...props }) => {
  return /* @__PURE__ */ React13.createElement(Toolbar3, props, precedingChildren, children, darkModeButton ? /* @__PURE__ */ React13.createElement(DarkModeIconButton, {
    color: "inherit"
  }) : null, menuItems ? /* @__PURE__ */ React13.createElement(SiteMenu, {
    onMenuToggle
  }, menuItems) : null);
}, "SystemToolbar");

// src/AppBar/Application.tsx
var ApplicationAppBar = /* @__PURE__ */ __name(({ logo, systemToolbar, contextToolbar, responsive = true, ...props }) => {
  return /* @__PURE__ */ React14.createElement(AppBarEx, {
    systemToolbar: systemToolbar ?? /* @__PURE__ */ React14.createElement(SystemToolbar, null),
    contextToolbar: contextToolbar ?? /* @__PURE__ */ React14.createElement(ContextToolbar, {
      logo
    }),
    position: "sticky",
    responsive,
    ...props
  });
}, "ApplicationAppBar");
export {
  AppBarEx,
  ApplicationAppBar,
  ContextToolbar,
  MenuListItemContainer,
  MenuSection,
  SiteMenu,
  SystemToolbar,
  useMenuItemsShared
};
//# sourceMappingURL=index.mjs.map